const OPEN_MODAL = "OPEN_MODAL";
const CLOSE_MODAL="CLOSE_MODAL";
const MODAL_MANAGE="manage";
const MODAL_ALERT="alert";
const MODAL_HOME="home";
const MODAL_CLASSDATA="classdata";
const MODAL_RANKINGLIST="rankingList";
const MODAL_STUDENTINFO="studentinfo";
const MODAL_ACTIVITYLIST="activityList";
const MODAL_ACTIVITYDETAIL="activityDetail";
const MODAL_DONGTAIDETAIL="dongtaiDetail";
const MODAL_VERSION="versionUpdate";
const MODAL_ZIPINGLIST="zipingList";
const MODAL_ACTIVITYSHENHE="activityShenhe";
const MODAL_TERMREPORT="termreport";

const openManage=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_MANAGE
    }
}
const closeManage=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_MANAGE
    }
}


const openAlert=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_ALERT
    }
}
const closeAlert=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_ALERT
    }
}
const openHomeModal=function(){

    return{
        type:OPEN_MODAL,
        modal:MODAL_HOME
    }
}
const closeHomeModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_HOME
    }
}

const openClassdataModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_CLASSDATA
    }
}
const closeClassdataModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_CLASSDATA
    }
}

const openRankingListModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_RANKINGLIST
    }
}
const closeRankingListModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_RANKINGLIST
    }
}
const openStudentinfoModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_STUDENTINFO
    }
}
const closeStudentinfoModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_STUDENTINFO
    }
}
const openActivityListModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_ACTIVITYLIST
    }
}
const closeActivityListModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_ACTIVITYLIST
    }
}
const openActivityDetailModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_ACTIVITYDETAIL
    }
}
const closeActivityDetailModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_ACTIVITYDETAIL
    }
}
const openDongtaiDetailModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_DONGTAIDETAIL
    }
}
const closeDongtaiDetailModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_DONGTAIDETAIL
    }
}
const openVersionUpdateModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_VERSION
    }
}
const closeVersionUpdateModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_VERSION
    }
}
const openZipingListModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_ZIPINGLIST
    }
}
const closeZipingListModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_ZIPINGLIST
    }
}
const openActivityShenheModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_ACTIVITYSHENHE
    }
}
const closeActivityShenheModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_ACTIVITYSHENHE
    }
}
const openTermreportModal=function(){
    return{
        type:OPEN_MODAL,
        modal:MODAL_TERMREPORT
    }
}
const closeTermreportModal=function () {
    return{
        type:CLOSE_MODAL,
        modal:MODAL_TERMREPORT
    }
}

export {
    openManage,
    closeManage,
    openAlert,
    closeAlert,
    openHomeModal,
    closeHomeModal,
    openClassdataModal,
    closeClassdataModal,
    openRankingListModal,
    closeRankingListModal,
    openStudentinfoModal,
    closeStudentinfoModal,
    openActivityListModal,
    closeActivityListModal,
    openActivityDetailModal,
    closeActivityDetailModal,
    openDongtaiDetailModal,
    closeDongtaiDetailModal,
    openVersionUpdateModal,
    closeVersionUpdateModal,
    openZipingListModal,
    closeZipingListModal,
    openActivityShenheModal,
    closeActivityShenheModal,
    openTermreportModal,
    closeTermreportModal
} ;
